import React, { Dispatch, PropsWithChildren, useEffect, useState } from 'react';
import { IStartChatData } from '../interfaces/api-interfaces-miaw';
import { IMessage } from '../interfaces/component-interfaces';
import { initializeWebStorage } from '../utils/miaw/web-storage-utils';
import { storeDeploymentDeveloperName, storeOrganizationId, storeSalesforceMessagingUrl } from '../utils/miaw/chat-config';

interface IMiawChatContextState {
  conversationStatus?: string;
  conversationId?: string;
  conversationMessages: IMessage[];
  agentName?: string;

  startMiawChatSession?: (data: IStartChatData) => void;
  endMiawChatSession?: () => void;
  sendMiawChatMessage?: (message: string) => void;

  endChatData?: string;
  endChatLoading?: boolean;

  isChatEndedByAgent?: boolean;
  isMIAWApiLoading?: boolean;

  isMIAWApiError?: boolean;
  isMIAWEndChatError?: boolean;
  isMIAWStartChatError?: boolean;
  isRoutingError?: boolean;

  showAttachmentError?: boolean;
  attachmentErrorMessage?: string;

  sendRoutingDataWithMessage?: boolean;
  studioDesignLink?: string;
  queueInfo?: {
    default: string;
    checkout?: string;
    design?: string;
    digital?: string;
  };
  sfConfig: {
    orgId: string;
    developerName: string;
    scrtURL: string;
  };
  enableTypingIndicator?: boolean;
  enableSneakPeak?: boolean;
}

interface IMiawChatContextProps {
  state: IMiawChatContextState;
  setState: Dispatch<React.SetStateAction<IMiawChatContextState>>;
}

export const MiawChatContext = React.createContext<IMiawChatContextProps>({
  state: { conversationMessages: [], sfConfig: { orgId: '', developerName: '', scrtURL: '' } },
  setState: () => {},
});

const MiawChatProvider: React.FC<PropsWithChildren<IMiawChatContextState>> = ({ children, queueInfo, sfConfig, enableTypingIndicator, enableSneakPeak }) => {
  const [state, setState] = useState<IMiawChatContextState>({ conversationMessages: [], queueInfo, sfConfig, enableTypingIndicator, enableSneakPeak });
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (sfConfig?.orgId) {
      initializeWebStorage(sfConfig.orgId);
      storeOrganizationId(sfConfig?.orgId);
      storeDeploymentDeveloperName(sfConfig?.developerName);
      storeSalesforceMessagingUrl(sfConfig?.scrtURL);
      setIsReady(true);
    }
  }, []);
  if (!isReady) return null;
  return (
    <MiawChatContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </MiawChatContext.Provider>
  );
};

export { MiawChatProvider };
